import { Component, inject } from '@angular/core';
import { ToastService } from '../../services/toast.service';
import { fadeIn, fadeOut } from '../../animations/animations';

@Component({
  selector: 'app-toast',
  imports: [],
  templateUrl: './toast.component.html',
  animations: [fadeIn, fadeOut]
})
export class ToastComponent {

  public toastService = inject(ToastService);

  get toasts() {
    return this.toastService.toasts;
  }

  remove(toast: any) {
    this.toastService.remove(toast);
  }
 }
